import { useMutation } from "@apollo/client";
import {
  ClientPreferenceFragmentFragmentDoc,
  UpdateClientPreferencesDocument,
} from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import type { NotificationSettingValues } from "@/containers/notifications/notification-settings/lib";
import {
  transformNotificationSettingsInput,
  transformNotificationSettingsPayload,
} from "@/containers/notifications/notification-settings/lib";
import { getFragmentData } from "@/__generated__";

type EnabledType = "automatedNotificationEnabled" | "autoPay";

export const useUpdateClientPreferencesMutation = () => {
  const [mutate, result] = useMutation(UpdateClientPreferencesDocument);

  const updatePreferences = (type: EnabledType, value: unknown) => {
    let values = value;
    if (type === "automatedNotificationEnabled") {
      values = transformNotificationSettingsPayload(
        value as NotificationSettingValues,
      );
    }
    return mutate({
      variables: {
        input: {
          clientId: useAuthState.getState().data.userInfo.id,
          preferences: {
            [type]: values,
          },
        },
      },
      onCompleted: (data) => {
        if (data.updateClientPreferences?.preferences) {
          const { automatedNotificationEnabled } = getFragmentData(
            ClientPreferenceFragmentFragmentDoc,
            data.updateClientPreferences.preferences,
          );

          useAuthState.getState().setUserInfo({
            notificationSettings: transformNotificationSettingsInput(
              automatedNotificationEnabled?.categories,
              automatedNotificationEnabled?.channels,
            ),
          });
        }
      },
    });
  };

  return { updatePreferences, ...result };
};
